import type { App } from 'vue'
import { withInstall } from '@touchvue/utils'
import Timeline from './src/timeline.vue'
import { defineComponent } from 'vue'

export const ToTimeline = withInstall(Timeline as ReturnType<typeof defineComponent>)

export type TimelineInstance = InstanceType<typeof Timeline>

export default {
	install(app: App) {
		app.component(ToTimeline.name, ToTimeline)
	},
}

export * from './src/timeline'
